import { combineReducers } from 'redux';
import hierarchyTree from './hierarchy-tree/hierarchy-tree';

export default combineReducers({
  hierarchyTree,
});
